// Auth constants
export const SET_ENVIRONMENT = 'action/SET_ENVIRONMENT';
export const SET_SESSION = 'action/SET_SESSION';


export default {
  SET_ENVIRONMENT,
  SET_SESSION
};
